export * from './lib/notifications.module';

export { NotificationService } from './lib/services/notification.service';
